import React, { FC } from 'react';
import getClassNames from '../../utils/getClassNames';

import styles from './WithOverlay.module.scss';

export type WithOverlayProps = {
  text: string;
  classNameModifier?: string;
};

const WithOverlay: FC<WithOverlayProps> = ({
  text, classNameModifier = 'full',
}) => (
  <div className={getClassNames(styles, 'root', classNameModifier)}>
    <div className={getClassNames(styles, 'overlay', classNameModifier)}>
      <span className={getClassNames(styles, 'callout', classNameModifier)}>{text}</span>
    </div>
  </div>
);

export default WithOverlay;
